export enum FeaturedProductKey {
    MOTO = 'MOTO',
    TRAVEL = 'TRAVEL',
    CDW = 'CDW',
    CAR = 'CAR',
    TRAVEL_CANCELLATION = 'TRAVEL_CANCELLATION',
}
